<template>
    <div class="d-flex align-items-center flex-column flex-md-row p-2 p-md-5">
        <div class="overlay__img--wrapper">
            <img src="@/assets/milestones/milestone__1966.jpg" class="img-fluid overlay__img">
        </div>
        <div class="milestone__info--overlay">
            <div class="milestone__year font-24 text-left">1966</div>
            <div class="milestone__headline font-bold font-32 text-left" v-html="$t('MILESTONE_1966_HEADLINE')">« Beloved by the sun » campaign</div>
            <div class="text-left d-flex flex-column align-items-start mt-3 mt-md-5">
                <div class="milestone__text font-18 mt-4" v-html="$t('MILESTONE_1966_TEXT_01')">
                    In 1966, Shiseido adopted the “sun” as the theme of its “Beloved by the Sun” summer campaign
                    featuring the healthy beauty of tanned skin. The campaign was a big success, turning people towards
                    the idea that tanned skin was part of a woman's right to be beautiful.
                </div>
                <div class="milestone__text font-18 mt-4" v-html="$t('MILESTONE_1966_TEXT_02')">
                    In addition, it was the first time in Japan that an overseas photo shoot had been done in Hawaii,
                    making the posters so popular for a time that they were being stolen from stores throughout Japan,
                    and the formerly unknown model, Bibari Maeda, became a star overnight.
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        name: "milestone-1966",
    }
</script>

<style scoped>

</style>